module.exports = __webpack_public_path__ + "static/media/timer.4c00b7eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GigDetail/timer.svg
// module id = 121
// module chunks = 0